import useTranslation from "next-translate/useTranslation";
import { useState } from "react";
import EnrollmentItems from "shared/components/organisms/EnrollmentItems";
import CourseThumbWithPlay from "./CourseThumbWithPlay";
import { Container, ContainerImage, EnrollmentSection } from "./styles";
import TrailerModalContent from "./TrailerModal";
import { TrailerModalContainer } from "./TrailerModal/styles";

const Play = ({ course }) => {
  const { t } = useTranslation();
  const [showTrailerModal, setShowTrailerModal] = useState(false);

  const hasTrailer = course.trailer_type !== "disabled" && course.use_trailer;

  const handleTrailerModal = () => {
    setShowTrailerModal(!showTrailerModal);
  };

  return (
    <Container className="course-play-container">
      {course && (
        <>
          <ContainerImage
            id="thumb-container"
            hasTrailer={hasTrailer}
            onClick={handleTrailerModal}
          >
            <CourseThumbWithPlay
              hasTrailer={hasTrailer}
              image_thumbnail={course.image_thumbnail}
            />
          </ContainerImage>

          {hasTrailer && showTrailerModal && (
            <TrailerModalContainer
              centered
              width={800}
              footer={null}
              title={t("common:courseTrailer")}
              visible
              onCancel={handleTrailerModal}
            >
              {showTrailerModal && (
                <TrailerModalContent
                  trailer={course.trailer}
                  trailer_type={course.trailer_type}
                  trailer_video_id={course.trailer_video_id}
                />
              )}
            </TrailerModalContainer>
          )}

          <EnrollmentSection>
            <EnrollmentItems
              entity={course}
              context="course"
              isCourseLandingPageCard={true}
            />
          </EnrollmentSection>
        </>
      )}
    </Container>
  );
};

export default Play;
